import teras from '@/teras'

import Vue from 'vue'
import VueRouter from 'vue-router'

import Socio from '@/components/Socio'
import SocioEdit from '@/components/Socio-edit'
import SocioPagamento from '@/components/Socio-pagamento'
import SocioNoregister from '@/components/Socio-noregister'

Vue.use(VueRouter)

var mode = (process.env.NODE_ENV != 'development') ? 'history' : 'hash'

const router = new VueRouter({

  mode: mode,
  base: '/diventasocio/',

  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  },

  routes: [
    { path: '/',  redirect: '/socio-edit'},
    
    { path: '/socio', name: 'socio', meta: { requiresAuth: false }, components: { main: Socio } }, 
    { path: '/socio-edit', name: 'socio.edit', meta: { requiresAuth: false }, components: { main: SocioEdit } }, 
    { path: '/socio-pagamento', name: 'socio.pagamento', meta: { requiresAuth: false }, components: { main: SocioPagamento } }, 
    { path: '/socio-noregister', name: 'socio.noregister', meta: { requiresAuth: false }, components: { main: SocioNoregister } }, 
    { path: '*', redirect: '/socio-edit' } 
  ]


})



router.beforeEach((to, from, next) => {
  console.log("\nbeforeEach \nfrom: "+from.path+"\nto: "+to.path+"\n\n")
  teras.router.from = from.path
  teras.router.to = to.path
  
  if(!teras.app.ready){
     if(teras.ttl()){
        console.log("TTLCLEAR lancio appClear")
        teras.event.emit('appClear')
     }
     console.log("EFFETTUO LE OPERAZIONI AL PRIMO AVVIO DELLA APP "+ teras.name)
     teras.event.emit('routerFirst', to)
     return true
  }

  if (to.matched.some(record => record.meta.requiresAuth)){
     console.log("SONO RICHIESTI I PERMESSI..... LI CONTROLLO")
     if(teras.app.auth){
        console.log("....PERMESSI VERIFICATI, PROCEDO!")
        next()
     }else{
        console.log("....PERMESSI MANCANTI, LO MANDO A: "+teras.app.routeInitial)
        teras.event.emit('routerNoauth',to)
        next(teras.app.routeNoauth)
     }
  }else{
     console.log("NON SONO RICHIESTI PERMESSI")
     next()
  }

  teras.event.emit('routerChange', to)
})

export default router
